import { BaseNode } from "../baseNode";
import { nodeConfigs } from "../nodeConfigs";
export const ApiNode = ({ id, data }) => (
  <BaseNode id={id} data={data} config={nodeConfigs.api} />
);
